import { render, staticRenderFns } from "./dispute-resolution-confirmation-dialog.vue?vue&type=template&id=5cc81683"
import script from "./dispute-resolution-confirmation-dialog.vue?vue&type=script&lang=js"
export * from "./dispute-resolution-confirmation-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports